import React, { useState } from "react";
import { Role } from "@/api/roles";
import { Link } from "react-router-dom";
import { DataGrid, DataGridColumn } from "@/ui-controls/DataGrid";
import { Application } from "@/api/applications";
import MoreActionsButton from "@/ui-controls/MoreActionsButton";
import DeleteAppRolePanel from "@/components/roles/appRoles/DeleteAppRolePanel";

interface Props {
  Application: Application;
  UserId?: number;
  RoleList: Role[];
  onDelete: (role: Role) => any;
}

enum MenuActionType {
  DEACTIVATE_ROLE = 1,
  ADD_PRIVILEGES,
}

const RoleDetailList = (props: Props) => {
  const countBadgeStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 32,
    height: 28,
    padding: "0 10px",
    borderRadius: 14,
    backgroundColor: "#f3f2f1",
    color: "#323130",
    fontWeight: 600,
    textDecoration: "none",
  };

  const [menuActionType, setMenuActionType] = useState<
    MenuActionType | undefined
  >(undefined);
  const [selectedRole, setSelectedRole] = useState<Role | undefined>(undefined);

  const buildPath = (item: Role) => {
    return props.UserId
      ? `/applications/${props.Application.Id}/users/${props.UserId}/roles/${item.Id}/privileges`
      : `/applications/${props.Application.Id}/roles/${item.Id}/privileges`;
  };

  const renderRoleAction = () => {
    if (!selectedRole || !menuActionType) return null;

    switch (menuActionType) {
      case MenuActionType.DEACTIVATE_ROLE:
        return (
          <DeleteAppRolePanel
            role={selectedRole}
            onClose={cleanRoleAction}
            onDelete={(role) => {
              props.onDelete(role);
            }}
          />
        );
      // case MenuActionType.ADD_USER:
      //   return (
      //     <AppCustomerUsers
      //       ApplicationId={props.Application.Id}
      //       CustomerId={selectedCustomer.Id}
      //       ShowOnlyNewAppCustomerUserPanel={true}
      //       onCloseNewAppCustomerUserPanel={cleanCustomerAction}
      //       onSaveAppCustomerUsers={(users) =>
      //         (selectedCustomer.UsersCount = users.length)
      //       }
      //     />
      //   );
      // case MenuActionType.RESTRICT_PRIVILEGES:
      //   return <p>TODO: RESTRICT_PRIVILEGES</p>;
      default:
        return null;
    }
  };

  const columns: DataGridColumn[] = [
    {
      key: "id",
      name: "Id",
      fieldName: "Id",
      minWidth: 50,
      maxWidth: 60,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "name",
      name: "Name",
      fieldName: "Name",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "Description",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "weight",
      name: "Weight",
      fieldName: "Weight",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "NoPrivileges",
      name: "Privileges",
      fieldName: "PrivilegesCount",
      minWidth: 70,
      maxWidth: 100,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
      onRender: (item: Role) => (
        <Link to={buildPath(item)} style={countBadgeStyle}>
          {item.PrivilegesCount}
        </Link>
      ),
    },
    {
      key: "Actions",
      name: "",
      minWidth: 50,
      maxWidth: 70,
      onRender: (item: Role) => (
        <MoreActionsButton
          menu={[
            {
              key: "deactivate",
              text: "Deactivate role",
              iconProps: { iconName: "Delete" },
              onClick: () => {
                setMenuActionType(MenuActionType.DEACTIVATE_ROLE);
                setSelectedRole(item);
              },
            },
            {
              key: "addSection",
              text: "Add",
              iconProps: { iconName: "Add" },
              subMenuProps: {
                items: [
                  // {
                  //   key: "addUser",
                  //   text: "User",
                  //   title: "Add application user",
                  //   onClick: () => {
                  //     setMenuActionType(MenuActionType.ADD_USER);
                  //     setSelectedCustomer(item);
                  //   },
                  // },
                  // {
                  //   key: "restrictPrivileges",
                  //   text: "Restrict Privileges",
                  //   title: "Restrict customer privileges",
                  //   onClick: () => {
                  //     setMenuActionType(MenuActionType.RESTRICT_PRIVILEGES);
                  //     setSelectedCustomer(item);
                  //   },
                  // },
                ],
              },
            },
          ]}
        />
      ),
    },
  ];

  const cleanRoleAction = () => {
    setSelectedRole(undefined);
    setMenuActionType(undefined);
  };

  return (
    <>
      <DataGrid items={props.RoleList} columns={columns} />
      {renderRoleAction()}
    </>
  );
};

export default RoleDetailList;
